// inizializzo le modali dinamiche in base agli ID
document.addEventListener("DOMContentLoaded", function() {
  const localizationSelectorsList = document.querySelectorAll(".localization-selector-popup");

  const seenIds = {};
  
  localizationSelectorsList.forEach((element) => {
    const originalId = element.id;

    // cerco se ci sono elementi ripetuti e in caso positivo aggiungo "MobileNav"
    if (seenIds[originalId]) {
      // se l'id è già presente incremento il contatore e modifico
      seenIds[originalId]++;
      
      element.id = originalId + "MobileNav";
    } else {
      // altrimenti tengo traccia dell'id
      seenIds[originalId] = 1;
    }
  });
  
  localizationSelectorsList.forEach(modalElement => {
    
    let locationId = document.querySelector("#" + modalElement.id + " > .localization-selector-popup__id").value;

    if (modalElement.id.indexOf("MobileNav") > -1) {
      locationId += "MobileNav";
    }
    
    const searchField = modalElement.querySelector("#search-input__" + locationId);
    const modalInstance = new LocalizationSelectorModal(modalElement.id, locationId);
    
    // apertura da bottone
    document.getElementById("localization-selector-popup__open-popup__" + locationId).addEventListener("click", () => {
      modalInstance.open(locationId);
    });

    // handle per ricerca
    searchField?.addEventListener('keyup', function() {
        // metto il testo lowercase per ricerca case insensitive
        const searchText = this.value.toLowerCase();
    
        const listItems = modalElement.querySelectorAll('.localization-selector__listbox .custom-select__option');
    
        // per ogni elemento della lista
        listItems.forEach(item => {
            // cerco il nome dei paesi nella lista
            const countryName = item.querySelector('.country-option__name').textContent.toLowerCase();
          
            // controllo se il testo della ricerca è contenuto nel nome del paese
            if (countryName.includes(searchText)) {
                item.style.display = 'flex';
            } else {
                item.style.display = 'none';
            }
        });
    });
  });
});

class LocalizationSelectorModal {
  constructor(modalId, locationId) {
    this.modal = document.getElementById(modalId);
    
    if (!this.modal) return;
    
    this.closeButton = this.modal.querySelector(".localization-selector-popup__close-popup");
    this.overlay = document.getElementById("localization-selector-popup__overlay__" + locationId);
    this.options = this.modal.querySelectorAll("ul li");
    
    this.closeButton.addEventListener("click", () => this.close(locationId));
    this.overlay.addEventListener("click", () => this.close(locationId));

    this.options.forEach(listItem => {
      listItem.addEventListener("click", () => this.close());
    });
  }

  open(locationId) {
    if (locationId.indexOf("MobileNav") > -1) {  
      document.getElementsByClassName("mobile-navigation-drawer")[0].scrollTo(0, 0);
      document.getElementsByClassName("mobile-navigation-drawer")[0].classList.add("no-scroll");
    }
    
    document.getElementsByTagName("body")[0].classList.add("no-scroll");
    this.modal.setAttribute('aria-hidden', 'false');
    this.overlay.setAttribute('aria-hidden', 'false');
  }

  close(locationId) {    
    if (locationId.indexOf("MobileNav") > -1) {
      document.getElementsByClassName("mobile-navigation-drawer")[0].classList.remove("no-scroll");
    }
    
    document.getElementsByTagName("body")[0].classList.remove("no-scroll");
    this.modal.setAttribute('aria-hidden', 'true');
    this.overlay.setAttribute('aria-hidden', 'true');
  }
}
